/**
 * Detect environment based on hostname
 */
function detectEnvironment(): 'dev' | 'prod' | 'local' {
  if (typeof window === 'undefined') return 'dev';
  const hostname = window.location.hostname;
  
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return 'local';
  }
  if (hostname.includes('-prod') || hostname.includes('prod.') || hostname.includes('alexein.com.au')) {
    return 'prod';
  }
  return 'dev';
}

/**
 * Get the Analyst Portal URL based on current environment
 */
function getAnalystPortalUrl(): string {
  const env = detectEnvironment();
  if (env === 'prod') return 'https://analyst.alexein.com.au';
  if (env === 'local') return 'http://localhost:5174';
  return 'https://zealous-sand-07573e100.3.azurestaticapps.net';
}

/**
 * Get the Operations Portal URL based on current environment
 */
function getOperationsPortalUrl(): string {
  const env = detectEnvironment();
  if (env === 'prod') return 'https://operations.alexein.com.au';
  if (env === 'local') return 'http://localhost:5173';
  return 'https://lemon-coast-0c746c300.3.azurestaticapps.net';
}

export const appEnv = {
  environment: detectEnvironment(),
  isProd: detectEnvironment() === 'prod',
  analystPortalUrl: getAnalystPortalUrl(),
  operationsPortalUrl: getOperationsPortalUrl(),
};
